import AvailabilitiesCalendarHeader from './AvailabilitiesCalendarHeader';

export default AvailabilitiesCalendarHeader;
